module.exports = __webpack_public_path__ + "static/img/解决方案-化工行业智能监管解决方案-危险区规范穿戴检测.4e60310e.png";